import { render, staticRenderFns } from "./InviteCamUserSidebar.vue?vue&type=template&id=8894c7c6&scoped=true&"
import script from "./InviteCamUserSidebar.vue?vue&type=script&lang=js&"
export * from "./InviteCamUserSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InviteCamUserSidebar.vue?vue&type=style&index=0&id=8894c7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8894c7c6",
  null
  
)

export default component.exports